import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { first, map, Observable, startWith } from 'rxjs';
import { Iemployees } from '../appel-a-support.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PostJsonObjectService } from '../../shared/services/post-json-object.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { tools } from '../../shared/services/tools';
import { SnackBarMessages } from '../../snack-bar-messages/snack-bar-messages';
import { MaterialModule } from '../../material-module';
import { CommonModule } from '@angular/common';
import { EnvoiFichier } from '../../envoi-fichier/envoi-fichier';
import { ClickOutsideDirective } from "../../shared/services/click-outside.directive";

@Component({
  selector: 'app-ajout-appel-a-support',
  standalone: true,
  imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, EnvoiFichier, ClickOutsideDirective],
  templateUrl: './ajout-appel-a-support.html',
  styleUrl: './ajout-appel-a-support.scss'
})

export class AjoutAppelASupportimplements implements OnInit {

  isLinear = true;
  formGroupArray: FormGroup[] = [];
  @ViewChild('stepper') public stepper: any;
  @Input() listSociety: any;

  public identifiantWebappelASupport: string = "";
  public filteredOptionsNom: Observable<string[]> = new Observable<string[]>();
  public isLoaded: boolean = false;
  public formulerSended: boolean = false;
  public guid: string = "";
  public userList: any[] = [];
  public societySelected: any;
  public userListState: number = 0; //loading
  public definitivTemporary: boolean = false;
  public canValidate: boolean = true;
  public isMatStepperEditable: boolean = true;
  public selectedIndex: number = 0;
  public employesMap = new Map<string, Iemployees>();

  constructor(private _formBuilder: FormBuilder,
    protected sanitizer: DomSanitizer,
    private postJsonObjectService: PostJsonObjectService,
    public dialog: MatDialog,
    private router: Router,
    private tools: tools) { }

  ngOnInit() {

    this.guid = this.tools.guid();

    //déclarant
    this.formGroupArray[0] = this._formBuilder.group({
      nom: ['', Validators.required]
      // prenom: ['', Validators.required]
    });

    //description
    this.formGroupArray[1] = this._formBuilder.group({
      sujet: ['', [Validators.required, Validators.minLength(5)]],
      description: ['', [Validators.required]]
    });

    this.isLoaded = true;

    //get list of employes
    if (this.listSociety.length == 1)
      this.parseEmployesList();

    this.filteredOptionsNom = this.formGroupArray[0].controls['nom'].valueChanges.pipe(
      startWith(''),
      map(value => this._filterUser(value)),
    );
  }

  public setSociety(ev: any) {
    this.societySelected = ev.value;
    this.parseEmployesList();
  }

  private parseEmployesList() {
    this.userList = [];
    if (this.listSociety.length == 1)
      this.societySelected = this.listSociety[0];

    for (let j = 0; j < this.societySelected.employees.length; j++) {
      this.userListState = 1;
      let employe: Iemployees =
      {
        "lastName": this.societySelected.employees[j].lastName,
        "firstName": this.societySelected.employees[j].firstName,
        "title": this.societySelected.employees[j].title,
        "displayName": this.societySelected.employees[j].displayName,
        "personUniqueid": this.societySelected.employees[j].personUniqueId
      };

      let userDisplay = {
        name: this.generateDisplayName(employe),
        idUnique: employe.personUniqueid
      };
      this.userList.push(userDisplay);

      this.employesMap.set(this.societySelected.employees[j].personUniqueid, employe);
    }
  }

  private generateDisplayName(user: Iemployees): string {
    let userdisplay: string = "";
    if (user?.displayName != '')
      return (user.displayName);
    if (user?.title != '')
      userdisplay = user.title + ". ";
    if (user?.firstName != '')
      userdisplay = userdisplay + user.firstName + " ";
    if (user?.lastName != '')
      userdisplay = userdisplay + user.lastName;

    return userdisplay;
  }

  private _filterUser(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.userList[this.societySelected].filter((option: any) => option.toLowerCase().includes(filterValue));
  }

  public validStepper(event?: any) {
    this.router.navigate(['/']).then(() => { this.router.navigate(['/appelASupport'], { queryParams: { idAs: this.identifiantWebappelASupport } }); });
  }

  public tabAsChange(event?: any) {
    if (event.selectedIndex == 2) {
      this.postAppelASupportWithoutDocs();
    }
  }

  public updateFormDeclarant(ev: any, componentid: any) {
    if (ev.isUserInput && componentid === 'nom') {
      this.formGroupArray[0]['controls']['nom'].setValue(ev.source.value);
    }
  }

  private postAppelASupportWithoutDocs() {

    let subject = "";
    if (this.formGroupArray[1]['controls']['sujet'].value != null)
      subject = this.formGroupArray[1]['controls']['sujet'].value;
    let message = "";
    if (this.formGroupArray[1]['controls']['description'].value != null)
      message = this.formGroupArray[1]['controls']['description'].value;
    let companyUniqueId = "";
    if (this.societySelected.companyUniqueId != null)
      companyUniqueId = this.societySelected.companyUniqueId;
    let authorUniqueId = "";
    if (this.formGroupArray[0]['controls']['nom'].value != null)
      authorUniqueId = this.formGroupArray[0]['controls']['nom'].value;

    let objectTosend =
    {
      "subject": subject,
      "companyUniqueId": companyUniqueId,
      "companyName": "",
      "conversation": [
        {
          "message": message,
          "authorUniqueId": authorUniqueId,
          "delegatorUniqueId": ""
        }
      ],
      "information": "",
      "attachments": [
      ]
    };

    return
  }

  public openErrorDialogBox() {
    const dialogRef = this.dialog.open(SnackBarMessages, {
      width: '550px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }


  public updateFilesSended(fileSended: any) {
    if (fileSended == false)
      this.canValidate = false;
    else {
      //check 
      this.canValidate = true;
    }
  }
}
